<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Что такое MyDonut</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="servis-dlya-avtomatizatsii-biznesa"
            class="typography__headline2"
          >
            Сервис для автоматизации бизнеса
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Создайте свой сайт-&#65279;приложение для быстрой продажи товаров и&nbsp;простой онлайн-записи
              на&nbsp;услуги. Сайт будет доступен как встроенное приложение в&nbsp;мессенджерах или по&nbsp;прямой
              ссылке откуда угодно.
            </p>

            <p>
              В&nbsp;MyDonut вам будут доступны самые нужные функции для ведения и&nbsp;автоматизации бизнеса: продажа
              товаров, онлайн-&#65279;записи, рабочее расписание сотрудников, чаты с&nbsp;клиентами, и&nbsp;многое
              другое.
            </p>

            <p>Управлять всем этим можно через удобную CRM-&#65279;систему даже со&nbsp;смартфона.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/сhto-takoye-donut-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="onlayn-zapis"
            class="typography__headline2"
          >
            Онлайн-запись
          </FaqArticlesBlockHeading>

          <p>
            Управляйте индивидуальными и&nbsp;групповыми записями всех филиалов через журнал, а&nbsp;рабочее расписание
            сотрудников повысит эффективность и&nbsp;прозрачность работы.
          </p>

          <BaseLink>Пример сайта с&nbsp;онлайн-&#65279;записями</BaseLink>

          <div>
            <h3 class="typography__title2">Функционал онлайн-&#65279;записей:</h3>

            <ul>
              <li>Управление записями всех филиалов через продуманный журнал</li>

              <li>Индивидуальные или групповые записи для любых целей</li>

              <li>Настройка и&nbsp;добавление новой записи по&nbsp;филиалу, сотруднику, услуге и&nbsp;времени</li>

              <li>Напоминания клиентам о&nbsp;предстоящих записях, переносах или отменах</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/onlayn-zapis"
          >
            Подробнее
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="zakazy-s-tovarami"
            class="typography__headline2"
          >
            Заказы с&nbsp;товарами
          </FaqArticlesBlockHeading>

          <p>
            Продавайте товары в&nbsp;удобном каталоге с&nbsp;гибкими настройками, а&nbsp;наша CRM не&nbsp;даст
            потеряться ни&nbsp;одному заказу и&nbsp;посчитает все остатки на&nbsp;складе.
          </p>

          <BaseLink>Пример сайта с&nbsp;интернет-&#65279;магазином</BaseLink>

          <div>
            <h3 class="typography__title2">Функционал интернет-&#65279;магазина:</h3>

            <ul>
              <li>Гибкая настройка категорий с&nbsp;отдельными фильтрами в&nbsp;каталоге</li>

              <li>Товары и&nbsp;их&nbsp;варианты по&nbsp;любым параметрам с&nbsp;подсчётом остатков</li>

              <li>Управление заказами и&nbsp;их&nbsp;статусами через продуманную систему</li>

              <li>Добавление настраиваемых типов доставки и&nbsp;их&nbsp;выбор для нужных товаров</li>

              <li>Извещение клиентов о&nbsp;смене статусов заказов и&nbsp;другие настраиваемые уведомления</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/zakazy-s-tovarami"
          >
            Подробнее
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="zayavki-na-uslugi"
            class="typography__headline2"
          >
            Заявки на&nbsp;услуги
          </FaqArticlesBlockHeading>

          <p>
            Предлагайте клиентам любые услуги с&nbsp;быстрой отправкой заявки, а&nbsp;при необходимости включите для них
            расписание и&nbsp;онлайн-&#65279;запись.
          </p>

          <BaseLink>Пример сайта с&nbsp;услугами для заявки</BaseLink>

          <div>
            <h3 class="typography__title2">Функционал заявок на&nbsp;услуги:</h3>

            <ul>
              <li>Управление заявками и&nbsp;их&nbsp;статусами через продуманную систему</li>

              <li>Возможность одной кнопкой переключить услугу на&nbsp;онлайн-&#65279;запись</li>

              <li>Гибкая настройка категорий с&nbsp;отдельными фильтрами в&nbsp;каталоге</li>

              <li>Извещение клиентов о&nbsp;смене статусов заявок</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/zayavki-na-uslugi"
          >
            Подробнее
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="sotrudniki"
            class="typography__headline2"
          >
            Сотрудники
          </FaqArticlesBlockHeading>

          <p>
            Управляйте быстро и&nbsp;удобно сотрудниками со&nbsp;всех филиалов, их&nbsp;рабочим расписанием
            и&nbsp;записями.
          </p>

          <div>
            <h3 class="typography__title2">Функционал сотрудников:</h3>

            <ul>
              <li>Управление сотрудниками через продуманную систему</li>

              <li>Гибко настраиваемое рабочее расписание сотрудников</li>

              <li>Напоминания и&nbsp;уведомления сотрудников о&nbsp;записях</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/sotrudniki"
          >
            Подробнее
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="klienty"
            class="typography__headline2"
          >
            Клиенты
          </FaqArticlesBlockHeading>

          <p>
            Напоминания и&nbsp;уведомления сотрудников о&nbsp;записяхУправляйте клиентами и&nbsp;их&nbsp;записями
            и&nbsp;заказами. Общайтесь с&nbsp;клиентами из&nbsp;разных мессенджеров в&nbsp;CRM, а&nbsp;бот поможет
            ответить на&nbsp;самые популярные вопросы за&nbsp;менеджера.
          </p>

          <div>
            <h3 class="typography__title2">Функционал клиентов:</h3>

            <ul>
              <li>Управление клиентами через продуманную систему</li>

              <li>Общение со&nbsp;всеми клиентами в&nbsp;одном месте через чат прямо в&nbsp;CRM</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/klienty"
          >
            Подробнее
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="bot-i-integratsii"
            class="typography__headline2"
          >
            Бот и&nbsp;интеграции
          </FaqArticlesBlockHeading>

          <p>Лёгкое подключение бота с&nbsp;настройкой автоматических ответов клиенту, уведомлений и&nbsp;команд.</p>

          <div>
            <h3 class="typography__title2">Функционал бота:</h3>

            <ul>
              <li>Помощь с&nbsp;созданием и&nbsp;подключение вашего бота в&nbsp;пару кликов</li>

              <li>Настройка активности и&nbsp;текстов в&nbsp;автоматических уведомлениях</li>

              <li>Настройка текстов в&nbsp;автоматических ответах</li>

              <li>Настройка главных команд бота</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/bot-i-integratsii"
          >
            Подробнее
          </BaseLink>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="sayt"
            class="typography__headline2"
          >
            Сайт
          </FaqArticlesBlockHeading>

          <p>
            Мы&nbsp;продумали почти все&nbsp;&mdash; останется только настроить фирменный цвет и&nbsp;добавить нужную
            информацию о&nbsp;компании.
          </p>

          <div>
            <h3 class="typography__title2">Функционал сайта:</h3>

            <ul>
              <li>Автоматическое создание сайта в&nbsp;зависимости от&nbsp;контента</li>

              <li>Настройка всего дизайна под фирменный стиль одним цветом</li>

              <li>Возможность поменять названия или вид разных элементов</li>

              <li>Создание кастомных страниц с&nbsp;дополнительной информацией</li>
            </ul>
          </div>

          <BaseLink
            class="base-button-big main-base-button-four"
            href="/faq/categories/sayt"
          >
            Подробнее
          </BaseLink>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Основная информация",
    url: "/faq/categories/osnovnaya-informatsiya",
  },
  {
    name: "Что такое MyDonut",
  },
];

const menu = [
  {
    name: "Сервис для автоматизации бизнеса",
    url: "servis-dlya-avtomatizatsii-biznesa",
  },
  {
    name: "Онлайн-&#65279;запись",
    url: "onlayn-zapis",
  },
  {
    name: "Заказы с&nbsp;товарами",
    url: "zakazy-s-tovarami",
  },
  {
    name: "Заявки на&nbsp;услуги",
    url: "zayavki-na-uslugi",
  },
  {
    name: "Сотрудники",
    url: "sotrudniki",
  },
  {
    name: "Клиенты",
    url: "klienty",
  },
  {
    name: "Бот и&nbsp;интеграции",
    url: "bot-i-integratsii",
  },
  {
    name: "Сайт",
    url: "sayt",
  },
];

const relatedArticles = [
  {
    name: "Тарифы",
    slug: "tarify",
  },
  {
    name: "Регистрация и&nbsp;начало работы",
    slug: "registratsiya-i-nachalo-raboty",
  },
  {
    name: "Контакты",
    slug: "kontakty",
  },
];

useSeoMeta({
  title: "Что такое MyDonut",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
